import { render } from "./FrameHint.vue?vue&type=template&id=3217e137&scoped=true"
import script from "./FrameHint.vue?vue&type=script&lang=js"
export * from "./FrameHint.vue?vue&type=script&lang=js"

import "./FrameHint.vue?vue&type=style&index=0&id=3217e137&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3217e137"]])

export default __exports__